module.exports = __webpack_public_path__ + "static/assets/d1f6af6170e0178514f35fedc62e5eab.svg";